var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallLogsEmptyState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3036_742413",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3036_742413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.0011 85.4173C73.149 85.4173 65.2605 83.5916 57.3355 79.9402C49.4111 76.2888 42.1237 71.1382 35.473 64.4882C28.8493 57.8375 23.7118 50.5562 20.0605 42.6444C16.4091 34.7333 14.5834 26.8517 14.5834 18.9996C14.5834 17.7496 15 16.701 15.8334 15.8538C16.6667 15.0072 17.7084 14.584 18.9584 14.584H32.548C33.6 14.584 34.5282 14.9274 35.3323 15.6142C36.1365 16.3003 36.648 17.1482 36.8667 18.1579L39.2552 30.4173C39.4205 31.5548 39.3858 32.5323 39.1511 33.3496C38.9157 34.167 38.4934 34.8534 37.8844 35.409L28.2615 44.7767C29.8101 47.6128 31.5796 50.2958 33.5698 52.8257C35.5594 55.3548 37.7136 57.7704 40.0323 60.0725C42.3184 62.3593 44.749 64.4829 47.324 66.4434C49.899 68.4038 52.6796 70.2281 55.6657 71.9163L65.0157 62.485C65.6678 61.8066 66.4573 61.3309 67.3844 61.0579C68.3108 60.7857 69.2737 60.7191 70.273 60.8579L81.8427 63.2142C82.8948 63.492 83.7535 64.0288 84.4188 64.8246C85.0841 65.6204 85.4167 66.5232 85.4167 67.5329V81.0423C85.4167 82.2923 84.9934 83.334 84.1469 84.1673C83.2997 85.0007 82.2511 85.4173 81.0011 85.4173Z",
    fill: "#E8E8E8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallLogsEmptyState);
export default __webpack_public_path__ + "static/media/call-logs_empty_state.55a7a01e81d7d2dc9fe72067145ead19.svg";
export { ForwardRef as ReactComponent };